const euclideanDistance = (startX: number, startY: number, endX: number, endY: number) : number => {
  const dx = endX - startX;
  const dy = endY - startY;
  return Math.sqrt(dx * dx + dy * dy);
}

export default euclideanDistance;